/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-13 12:32:50
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-08-29 14:18:57
 */
import { Breadcrumb } from '@didi-pebble/pebble-design-react';
import { useAtomValue } from 'jotai';

import { breadcrumbAtom } from '@/store';

const HeaderBreadcrumb: React.FC = () => {
  const { Item } = Breadcrumb;
  const breadcrumb: any = useAtomValue(breadcrumbAtom);

  return breadcrumb.length > 0 ? (
    <Breadcrumb style={{ height: 38, padding: '16px 28px 0' }}>
      {breadcrumb?.map((item: any, index: any) => {
        return <Item key={index}>{item}</Item>;
      })}
    </Breadcrumb>
  ) : (
    <></>
  );
};

export default HeaderBreadcrumb;
